import * as Yup from "yup";

export const shiftPolicyValidation = Yup.object().shape({
  // shiftPolicyID: Yup.number().required("shiftPolicyID is required"),
  shiftName: Yup.string().required("Shift Name is required"),
  shiftType: Yup.string(), //.required("Shift Type is required"),
  shiftStartTime: Yup.string().required("Shift Start Time is required"),
  shiftEndTime: Yup.string().required("Shift End Time is required"),
  shift1stHalfDayEndTime: Yup.string().required(
    "Shift 1stHalf Day End Time is required"
  ),
  shift2ndHalfDayStartTime: Yup.string().required(
    "Shift 2ndHalf Day Start Time is required"
  ),
  shiftLoginGraceTime: Yup.string()
    .typeError("Earliest Clock In is requried")
    .required("Shify Login Grace In is requried"),
  // earliestClockIn: Yup.string()
  //   .typeError("Earliest Clock In is requried")
  //   .required("Earliest Clock In is requried"),
  isPremiumOT: Yup.bool(), //.required("is Premium OT or Not is required"),
  shiftTypeID: Yup.number()
    .typeError("Select Shift Type required")
    .required("Select Shift Type required"),
  otMinimumHours: Yup.number()
    .min(0, "OT Minimum Hours is required")
    .typeError("OT Minimum Hours is required")
    .required("OT Minimum Hours is required"),
  otRoundOffMinimum: Yup.number()
    .min(0, "OT Round Off Minimum is required")
    .typeError("OT Round Off Minimum is required")
    .required("OT Round Off Minimum is required"),
  otStartTime: Yup.string()
    .typeError("OT Start Time is required")
    .when("isPremiumOT", {
      is: true,
      then: (schema) =>
        schema
          .required("OT Start Time is required")
          .test(
            "otStartTime-not-between-shift",
            "OT Start Time should not be between Shift Start and End Time",
            function (value) {
              const { shiftStartTime, shiftEndTime } = this.parent;
              if (!value || !shiftStartTime || !shiftEndTime) return true;
              return value <= shiftStartTime || value >= shiftEndTime;
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
  otEndTime: Yup.string()
    .typeError("OT End Time is required")
    .when("isPremiumOT", {
      is: true,
      then: (schema) =>
        schema
          .required("OT End Time is required")
          .test(
            "otEndTime-not-between-shift",
            "OT End Time should not be between Shift Start and End Time",
            function (value) {
              const { shiftStartTime, shiftEndTime } = this.parent;
              if (!value || !shiftStartTime || !shiftEndTime) return true;
              return value <= shiftStartTime || value >= shiftEndTime;
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

  // latestClockIn: Yup.number()
  //   .typeError()
  //   .required("Latest Clock In is requried"),
  // shiftAllowance: Yup.number()
  //   .typeError()
  //   .required("Shift Allowance is requried"),
  // additionalHour: Yup.number()
  //   .typeError()
  //   .required("Additional Hour is requried"),
  // shiftGraceTime: Yup.number()
  //   .typeError()
  //   .required("Shift Grace Time is requried"),
  // mealAllowance: Yup.number()
  //   .typeError()
  //   .required("Meal Allowance is requried"),
  // breakHourOTRate: Yup.number()
  //   .typeError()
  //   .required("Break Hour OT Rate is requried"),
  // earlyClockInOTRate: Yup.number()
  //   .typeError()
  //   .required("Early Clock In OT Rate is requried"),
  // shiftTypeID: Yup.number(),
  // .required("Shift Type ID is requried"),
  //   isActive: Yup.bool().required("isActive is required"),
});

export const shiftRotationValidationSchema = Yup.object().shape({
  scheduleFromDate: Yup.string().required("From Date is required"),
  scheduleToDate: Yup.string().required("To Date is required"),
  shiftRotation: Yup.array().of(
    Yup.object().shape({
      group: Yup.string()
        .typeError("Group is required")
        .required("Group is required"),
      shift: Yup.number()
        .typeError("Shift is required")
        .required("Shift is required"),
    })
  ),
  remarks: Yup.string().required("Remarks is required"),
  isActive: Yup.boolean().required("Status is required"),
});
